import Banner from "../../components/Banner";
import Offer from "../../components/Offer";
import Form from "./components/Form";
import Cards from "../../components/Cards";
import PageWrapper from "../../components/ui/wrappers/PageWrapper";
import Seo from "../../components/Seo";

const HomeEmprunteur = () => {
    const userType = "emprunteur";
    const cards = [
        {
            title: "Developper votre activite",
            content: (
                <ul className="list-disc m-2">
                    <li>Dotez-vous de ressources complementaires pour accelerer</li>
                    <li>Acquisition de nouveaux equipements</li>
                    <li>Accroissement de votre BFR</li>
                    <li>Developpement d'une nouvelle activite</li>
                    <li>Frais de lancement marketing et commercial</li>
                    <li>Recrutement</li>
                </ul>
            ),
            bgColor: "bg-primary",
            textColor: "text-white"
        },
        {
            title: "Renforcer votre tresorerie",
            content: (
                <ul className="list-disc m-2">
                    <li>Conservez votre liberte d'entreprendre</li>
                    <li>Anticipation des fluctuations de tresorerie</li>
                    <li>Constitution de stocks</li>
                    <li>Prefinancement de vos creances mais aussi vos futures aides publiques</li>
                    <li>Minimiser l'impact des delais de paiement de vos grands donneurs d'ordre</li>
                </ul>
            )
        },
        {
            title: "Conquerir de nouveaux marches",
            content: (
                <ul className="list-disc m-2">
                    <li>Explorez de nouvelles opportunites business en France ou a l'international</li>
                    <li>Lancement de nouveaux produits ou de nouvelles offres</li>
                    <li>Ventes a l'export</li>
                    <li>Prospection de nouveaux marches</li>
                    <li>Investissement ou creation de filiales a l'etranger</li>
                </ul>
            )
        },
        {
            title: "Servir votre ambition",
            content: (
                <ul className="list-disc m-2">
                    <li>Faites un premier pas en direction du futur;</li>
                    <li>Operation de croissance externe;</li>
                    <li>Acquisition de murs ou de batiments;</li>
                    <li>Renforcement de vos equipes et recrutement de nouveaux talents;</li>
                    <li>Digitalisation ou modernisation de vos outils de production.</li>
                </ul>
            ),
            bgColor: "bg-primary",
            textColor: "text-white"
        }
    ];

    const backgroundClass = userType === "emprunteur" ? "bg-primary" : "bg-secondary";
    const lightClass = userType === "emprunteur" ? "bg-primaryLight" : "bg-secondaryLight";
    const darkClass = userType === "emprunteur" ? "bg-primaryDark" : "bg-secondaryDark";

    return (
        <div>
            <Seo
                title="Emprunteur : financer votre entreprise"
                description="Vous etes emprunteur ? Decouvrez le financement participatif PretUp et deposez votre demande pour financer votre entreprise simplement et rapidement."
            />
            <Banner userType={userType} />
            <PageWrapper>
                <h2 className="base-h2-primary mb-12">Quelle que soit votre situation, nous avons la solution.</h2>
                <div className="mb-12 md:mb14 xl:mb-24">
                    <Cards
                        cards={cards}
                        className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-8"
                        cardType="card"
                    />
                </div>
                <Offer
                    backgroundClass={backgroundClass}
                    lightClass={lightClass}
                    darkClass={darkClass}
                />
                <Form className="mx-auto bg-gray-100 rounded-lg shadow-md sm:p-6 lg:p-8" />
            </PageWrapper>
        </div>
    );
};

export default HomeEmprunteur;
